const passwordPattern = {
  number: /\d/,
  specialChar: /[!@#$%^&*(),.?":{}|<>]/,
  uppercase: /[A-Z]/,
  lowercase: /[a-z]/,
};

function validatePassword(password, errorsArray) {
  if (!password || !password.length) {
    errorsArray.push({ location: 'password', message: 'Wachtwoord is niet ingevuld.' });
  } else {
    if (password.length < 8) {
      errorsArray.push({ location: 'password', message: 'Wachtwoord moet minstens 8 tekens lang zijn.' });
    }
    if (!passwordPattern.number.test(password)) {
      errorsArray.push({ location: 'password', message: 'Wachtwoord moet minstens 1 nummer bevatten.' });
    }
    if (!passwordPattern.specialChar.test(password)) {
      errorsArray.push({ location: 'password', message: 'Wachtwoord moet minstens 1 speciaal teken bevatten.' });
    }
    if (!passwordPattern.uppercase.test(password)) {
      errorsArray.push({ location: 'password', message: 'Wachtwoord moet minstens 1 hoofdletter bevatten.' });
    }
    if (!passwordPattern.lowercase.test(password)) {
      errorsArray.push({ location: 'password', message: 'Wachtwoord moet minstens 1 kleine letter bevatten.' });
    }
  }
}

export { validatePassword };
